<template>
    <div class="flex flex-col items-center">
        <img :src="logoUrlNoTagline"
             alt="Normal-logo"
             class="logo">
        <span class="mt-5 font-fauli text-[5px] font-semibold xs:hidden md:text-[7.5px] lg:block logo-tagline">{{ $translate('General.Logo.Tagline') }}</span>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import logoUrlNoTagline from '@/assets/images/logo-notagline.svg';

export default defineComponent({
    name: 'LogoAndTaglineHiddenOnXs',
    setup() {
        return {
            logoUrlNoTagline,
        };
    },
});
</script>

<style scoped>
    .logo {
        width: 9.75rem;
        transition: all 300ms ease-in-out;
    }

    .logo-tagline {
        transition: all 300ms ease-in-out;
    }

    @screen lg {
        .logo {
            width: 15.8rem;
        }
    }
</style>
